

const TableHeader = ({ title, backgroundColor, onClick, isSortable }) => (
    <th
      className={`text-white font-semibold p-3 border-r-4 border-gray-400 table_heeader ${
        isSortable ? 'cursor-pointer hover:bg-opacity-80' : ''
      }`}
      style={{ backgroundColor }}
      onClick={isSortable ? onClick : undefined}
    >
      {title} {isSortable && <span>&#8645;</span>}
    </th>
  );
  
  const TableCell = ({ children, colSpan = 1, className }) => (
    <td colSpan={colSpan} className={`border-r border-gray-300 p-2 ` + className}>
      {children}
    </td>
  );


export { TableHeader, TableCell };